export { createI18nInstance } from './create-i18n-instance';
